import { motion } from 'framer-motion';
import Tooltip from '../components/Tooltip';

export const pageTransition = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	transition: { duration: 0.4 }
};

export const buttonVariants = {
	hover: { scale: 1.02 },
	tap: { scale: 0.98 }
};

export const renderButton = (onClick, icon, text, bgColor, disabledReason) => {
	const isDisabled = disabledReason && disabledReason !== '';
	const buttonClass = `inline-flex items-center px-3 py-2 text-[11px] font-semibold text-white ${bgColor} rounded-lg focus:outline-none transition-all duration-200 ${isDisabled ? 'opacity-30 cursor-not-allowed' : 'hover:opacity-90'}`;

	return (
		<Tooltip content={isDisabled ? disabledReason : ''}>
			<button onClick={onClick} disabled={isDisabled} className={buttonClass}>
				{icon}
				<span className="ml-1.5">{text}</span>
			</button>
		</Tooltip>
	);
};

export const renderLoadingState = () => (
	<motion.div {...pageTransition} className="max-w-4xl mx-auto py-16 text-center">
		<div className="w-6 h-6 border-2 border-white/20 border-t-yellow-300 rounded-full animate-spin mx-auto mb-4" />
		<p className="text-white/30 text-xs">Loading...</p>
	</motion.div>
);

export const renderErrorState = (error) => (
	<motion.div {...pageTransition} className="max-w-4xl mx-auto py-12">
		<div className="bg-white rounded-2xl shadow-glass p-8 border border-gray-100">
			<p className="text-red-500 text-xs">Error: {error}</p>
		</div>
	</motion.div>
);
